<template>
    <v-container>
        <list-expense-reports class="mt-5" :userId="userId" :clientId="clientId" />
    </v-container>
</template>

<script>
import ListExpenseReports from '../../components/expenseReports/ListExpenseReports.vue'
export default {
    components: { ListExpenseReports },
    computed: {
        userId() {
            return this.$route.params.id || null
        },
        clientId() {
            return this.$route.params.clientId || null
        }
    },
}
</script>

<style></style>